export const SDV_501_INST_USER = "Sorry, you have not been assigned to any group yet. Please contact your administrator.";
export const SDV_501_END_USER = "Sorry, you have not been assigned to any group yet. Please contact your advisor.";
export const SDV_404_NOT_FOUND = "We're sorry for inconvenience. We can't find what you are looking for."
export const SDV_401_MISSING_TOKEN = "Missing Authorization Token.";
